export enum ExceptionType {
    APPOINTMENT = 1,
    INSPECTOR = 2,
}
